<template>
    <Teleport to="#app">
        <input type="checkbox" id="quantity" class="modal-toggle" />
        <div class="modal" id="modal-quantity">
            <div class="modal-box max-w-xs">
                <p>{{ __('Enter the desired number') }}</p>
                <input type="number" dir="ltr" :placeholder="__('Count')" class="input w-full text-center" />
                <div class="modal-action">
                    <label class="btn btn-primary btn-sm btn-add" for="quantity">{{ __('add') }}</label>
                    <label class="btn btn-error btn-sm" for="quantity" @click="setListener">{{ __('Cancel') }}</label>
                </div>
            </div>
        </div>
    </Teleport>
</template>
<script setup>
</script>